import { type CoralBreakpoint } from "@octopus-energy/coral-design"
import { token } from "@octopus-energy/coral-design/tokens"

export function mq(breakpoint: CoralBreakpoint, type: "min-width" | "max-width" = "max-width") {
    return () => `@media (${type}: ${token(`breakpoints.${breakpoint}`)}px)`
}

export function getMediaQueries() {
    const breakpoints: CoralBreakpoint[] = ["xl", "lg", "md", "sm", "xs"]

    return breakpoints.reduce(
        (mediaQueries, size) => {
            mediaQueries[size] = mq(size)()

            return mediaQueries
        },
        <Record<CoralBreakpoint, string>>{}
    )
}

export function getMediaQuery(
    breakpoint: CoralBreakpoint,
    type: "min-width" | "max-width" = "min-width",
    queryType: string | null = "@media"
) {
    return () =>
        [queryType, `(${type}: ${token(`breakpoints.${breakpoint}`)}px)`].filter(Boolean).join(" ")
}
